import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import "./navbar.css"


function Navbar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  return (
    <AppBar position="static" className='nav-main' >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            component="a"
            href="/"
            sx={{
              display: { xs: 'none', md: 'flex', textDecoration:'none' },
            }}
          > <img src="./images/ahsan.png" alt="logo" className='logo' />
          </Typography>
            <Typography component="a" href="/" className="logo-name" sx={{
              display: {  md: 'flex', textDecoration:'none' },
            }}>
               &nbsp;&nbsp;Ahsan <span style={{color:'#cdcdcd'}}>&nbsp;Iqbal</span>
            </Typography>
          
          {/* Ham Burger */}
          {/* <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
             
              sx={{
                display: { xs: 'block', md: 'none', },
              }}
              className="mobile"
            >
              <MenuItem className="mobile-menu">
              <a href="#hero-section">
                <Typography className="mobile-item">About Me</Typography>
                </a>
                <Typography   component="a"
                  href="skill-section" className="mobile-item">Skills</Typography>
                <a href="#project-section">
                  <Typography className="mobile-item">Projects</Typography>

                </a>
              </MenuItem>
            </Menu>
          </Box> */}
              {/* Mobile Logo */}
          <Typography
            component="a"
            href="/"
            sx={{
              display: { xs: 'flex', md: 'none',  justifyContent:'center' },
              flexGrow: 1,
            }}
          >
          <img src="./images/ahsan.png" alt="logo" sx={{display: { xs: 'none', md: 'flex', }}} className='logo' />
          </Typography>

            {/* Mobile Dropdown Menu */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex', flexDirection:'row-reverse' } }}>
              <a href="#hero-section">
                <Button
                  className="menu-item"
                > About Me </Button>
              </a>
              <a href="#skill-section">
                <Button
                  className="menu-item"
                > Skills </Button>
              </a>
              <a href="#project-section">
                <Button
                  className="menu-item"
                > Projects </Button>
              </a>
          </Box>

          <Box sx={{ flexGrow: 0, }}>
            <Tooltip title="Hire Ahsan">
              <IconButton>
                <a href="mailto:ahsan.chy.iqbal.com?subject=Hi!%20I%20want%20To%20Hire%20you" target="_blank" rel="noreferrer">
                  <Button className="hire-btn">
                      Hire Me
                  </Button>
                </a>
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Navbar;
